<template>
  <div v-loading="isLoading">
    <div>
      <div class="cs-title cs-bold">
        <span>学业分析报告</span>
      </div>
    </div>
    <div>
      <table style="width: 100%;">
        <tr v-for="(item, index) in modelList" :key="index">
          <td>
            <span>{{calcDateText(item.CreateTime)}}</span>
          </td>
          <td>
            <el-button :loading="isDownloading" :disabled="isDownloading" type="text" size="medium" @click="onDownloadFileClick(item)">{{item.FileStorageName}}</el-button>
          </td>
          <td>
            <el-button v-if="!isReadonly" :disabled="isLoading" type="text" size="medium" class="cs-redLabel" @click="onRemoveFileClick(item)">删除</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div class="cs-footer" v-if="!isReadonly">
      <el-button type="primary" size="mini" @click="onUploadFileClick">上传文件</el-button>
    </div>
    <el-dialog center title="上传学业分析报告" :show-close="true" :close-on-click-modal="false" width="700px" :visible.sync="blobUploaderVisible" top="8vh"
      z-index="2000">
      <blobUploader @closeEditor="onCloseBlobkUploader" @blobUploadError="onBlobUploaderError" @blobUploaded="onBlobUploaderUploaded" :type="12"
        :accepts="'.pdf'" :maxNameLength="32" :isVisible="blobUploaderVisible" :isMulti="true" :isAutoSave="true">
      </blobUploader>
    </el-dialog>
  </div>
</template>

<script>
import { downloadFile } from "@/config/mUtils";
import {
  getBlobFileUrlById,
  downloadFileToBlob,
} from "@/service/blobStorage.service";
import {
  getStudyAbroadAcademicAnalysisReportFileList,
  saveStudyAbroadAcademicAnalysisReportFiles,
  removeStudyAbroadAcademicAnalysisReportFile,
} from "@/service/studyAbroad.service";

const mixin_generalMethods = {
  methods: {
    calcDateText(value, format = "YYYY/MM/DD") {
      let mValue = this.$moment(value);
      if (!mValue.isValid()) return String.empty;

      return mValue.format(format);
    },
  },
};

export default {
  name: "academicAnalysisReport",
  mixins: [mixin_generalMethods],
  components: {
    blobUploader: () => import("@/components/fileHandler/blobUploader"),
  },
  props: {
    isReadonly: Boolean,
    studentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      blobUploaderVisible: false,
      modelList: [],
      isDownloading:false
    };
  },
  created() {
    this.loadStudyAbroadAcademicAnalysisReportFileListFromServer();
  },
  methods: {
    // 与服务端交互数据相关方法
    async loadStudyAbroadAcademicAnalysisReportFileListFromServer() {
      this.isLoading = true;
      try {
        let result = await getStudyAbroadAcademicAnalysisReportFileList(
          this.studentId
        );
        this.modelList =
          !!result && result.success && !!result.data ? result.data : [];
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async saveStudyAbroadAcademicAnalysisReportFilesToServer(data) {
      this.isLoading = true;
      try {
        let result = await saveStudyAbroadAcademicAnalysisReportFiles(data);
        if (!!result && result.success && result.data) {
          this.$message.success("上传学业分析报告成功。");

          await this.loadStudyAbroadAcademicAnalysisReportFileListFromServer();
        } else {
          this.$message.error("上传学业分析报告失败。");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async removeStudyAbroadAcademicAnalysisReportFileToServer(fileId) {
      this.isLoading = true;
      try {
        let result = await removeStudyAbroadAcademicAnalysisReportFile(fileId);
        if (!!result && result.success && result.data) {
          this.$message.success("删除学业分析报告成功。");

          await this.loadStudyAbroadAcademicAnalysisReportFileListFromServer();
        } else {
          this.$message.error("删除学业分析报告失败。");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    onUploadFileClick(e) {
      this.blobUploaderVisible = true;
    },
    onBlobUploaderUploaded(data) {
      if (!data) {
        this.blobUploaderVisible = false;
        return;
      }

      let modelList = [];
      data.forEach((item) => {
        modelList.push({
          StudentId: this.studentId,
          FileStorageId: item.FileId,
          FileStorageName: item.FileName,
        });
      });
      this.$nextTick(async () => {
        await this.saveStudyAbroadAcademicAnalysisReportFilesToServer(
          modelList
        );
        this.blobUploaderVisible = false;
      });
    },
    onBlobUploaderError() {},
    onCloseBlobkUploader() {},
    onDownloadFileClick(row) {
      this.isDownloading = true;
      getBlobFileUrlById(row.FileStorageId, 11)
        .then((result) => {
          if (!!result && result.success) {
            let { Url, FileName } = result.data;
            downloadFileToBlob(Url, 0).then((res) => {
              downloadFile({ data: res.data, filename: FileName });
            });
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }
          }
          this.isDownloading = false;
        })
        .catch(() => {
          this.isDownloading = false;
        });
    },
    onRemoveFileClick(row) {
      this.$confirm("您确认要删除该文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.removeStudyAbroadAcademicAnalysisReportFileToServer(row.Id);
        })
        .catch(() => {});
    },
  },
  watch: {
    studentId(newVal) {
      this.loadStudyAbroadAcademicAnalysisReportFileListFromServer();
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-title {
  height: 40px;
  line-height: 40px;
}

.cs-footer {
  height: 40px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/academicInfo/academicAnalysisReport.vue